import { Icon, Stack, Text } from '@fluentui/react';
import { useLocation } from 'react-router';
import { TSettingsCategory } from './Dashboard';
import { TransitionGroup } from 'react-transition-group';
import { forwardRef, useMemo } from 'react';
import { CSSTransitionWithRefRenderProps } from '../../_components/CSSTransitionWithRefRenderProps';
import { useGetSettings } from '../../_contexts/settings/settingsContext';

export const Headliner = ({ category }: { category: TSettingsCategory }) => {
    const { pathname } = useLocation();
    const description = useMemo(() => {
        if (!category.description) {
            return <Text variant="large">{category.shortDescription}</Text>;
        }
        if (typeof category.description === 'function') {
            const Description = category.description;
            return <Description />;
        }
        return category.description;
    }, [category.description, category.shortDescription]);
    return (
        <TransitionGroup key={pathname} appear>
            <CSSTransitionWithRefRenderProps mountOnEnter unmountOnExit timeout={{ enter: 100, exit: 0 }} classNames={'setttings-header'}>
                {ref => (
                    <HeadlineContainer ref={ref}>
                        <Stack horizontalAlign="center" horizontal verticalAlign="center" tokens={{ childrenGap: 10, padding: '10px 0 0 0' }}>
                            <CategoryLogo category={category} />
                            <Text variant="xxLarge">{category.title}</Text>
                        </Stack>
                        {description}
                    </HeadlineContainer>
                )}
            </CSSTransitionWithRefRenderProps>
        </TransitionGroup>
    );
};

const CategoryLogo = ({ category }: { category: TSettingsCategory }) => {
    const Logo = category.icon;
    return <>{Logo ? <Logo height={'50.29px'} width={'32px'} /> : <Icon iconName={category.iconName} styles={{ root: { fontSize: '1.5rem' } }} />}</>;
};

const HeadlineContainer = forwardRef<HTMLDivElement, { style?: React.CSSProperties; children: React.ReactNode }>(({ children, style }, ref) => {
    const { editableSettings, settings } = useGetSettings();

    const settingsHasChanged = useMemo(() => settings !== editableSettings, [editableSettings, settings]);
    const styles = useMemo(() => {
        const containerStyles: React.CSSProperties = {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            paddingTop: settingsHasChanged ? 42 : 10,
            gap: 10,
        };
        return {
            ...containerStyles,
            ...style,
        };
    }, [style, settingsHasChanged]);
    return (
        <div style={styles} ref={ref}>
            {children}
        </div>
    );
});
